export default {
	meta: {
		title: 'Parcours-maternite-assure',
		titleTemplate: '%s | CNAM',
		description: 'Parcours assuré maternité et santé de l&#39;enfant.'
	}
};
